import React, { useContext } from 'react';
import styled from 'styled-components';
import { FiltersContext } from '../../context/FiltersContext';
import { FiltersContextType } from '../../context/types/FiltersContextType';
import { UploadLookContext } from '../../context/UploadLookContext';
import { UploadLookContextType } from '../../context/types/UploadLookContextType';
import { TextRegular } from '../Text';
import {
  MIN_TABLET_BODY_WIDTH,
  MIN_PC_BODY_WIDTH,
  MIN_PC_S_BODY_WIDTH,
  MIN_MOBILE_BODY_WIDTH,
} from '../../constants/StylistConstants';

type ModalScreenProps = {
  children: React.ReactNode;
  label: string;
};

const ModalScreen = (props: ModalScreenProps) => {
  const { showFilters, saveShowFilters } = useContext(
    FiltersContext,
  ) as FiltersContextType;

  const { showUploadLook, saveShowUploadLook } = useContext(
    UploadLookContext,
  ) as UploadLookContextType;

  const closeUploadModal = () => {
    if (showFilters) saveShowFilters(false);
    if (showUploadLook) saveShowUploadLook(false);
  };
  return (
    <Container>
      <Wrapper>
        <Header>
          <Left>
            <TextRegular fontWeight={600}>{props.label}</TextRegular>
          </Left>
          <Right
            onClick={() => {
              closeUploadModal();
            }}
          >
            <TextRegular fontWeight={600}>x close</TextRegular>
          </Right>
        </Header>
        <Body>{props.children}</Body>
      </Wrapper>
    </Container>
  );
};

const Container = styled.div`
  width: ${MIN_PC_BODY_WIDTH}px;
  background-color: white;
  position: absolute;
  display: flex;
  justify-content: center;
  z-index: 10;
  border: 1px solid #000000;

  @media (max-width: ${MIN_PC_BODY_WIDTH - 1}px) {
    width: ${MIN_PC_S_BODY_WIDTH}px;
  }

  @media (max-width: ${MIN_PC_S_BODY_WIDTH - 1}px) {
    width: ${MIN_TABLET_BODY_WIDTH}px;
  }

  @media (max-width: ${MIN_TABLET_BODY_WIDTH - 1}px) {
    width: ${MIN_MOBILE_BODY_WIDTH}px;
  }
`;

const Wrapper = styled.div`
  width: 100%;
`;

const Header = styled.div`
  width: 85%;
  margin: auto;
  padding-top: 25px;
  padding-bottom: 25px;
  border-bottom: 1px black solid;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: ${MIN_PC_S_BODY_WIDTH - 1}px) {
    padding-bottom: 10px;
  }
`;

const Left = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
`;

const Right = styled.div`
  cursor: pointer;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const Body = styled.div`
  padding-top: 25px;
`;

export default ModalScreen;
